import React, { memo } from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';

import General from '../../General/General';
import Environment from '../../Environment/Environment';
import Platform from '../../Platform/Platform';
import Billing from '../../Billing/Billing';
import Licensing from '../../Licensing/Licensing';
import Children from '../../Children/Children';
import ArrActivity from '../../ArrActivity/ArrActivity';
import PlatformRouts from 'components/Customer/Platform/PlatformRouts/PlatformRouts';
import Satisfaction from '../../Satisfaction/Satisfaction';
import SatisfactionRouts from '../../Satisfaction/SatisfactionRouts/SatisfactionRouts';
import { access, resources, hasAccess } from 'utils/permissions';

import classes from './CustomerInfoRoutes.module.scss';

const CustomerInfoRoutes = ({ url, customerId, status, plan }) => {
  return (
    <section className={classes.routs}>
      {hasAccess([resources.CUSTOMERS, access.READ]) && (
        <Route exact path={`${url}/general`}>
          <General customerId={customerId} status={status} />
        </Route>
      )}

      {hasAccess([resources.CUSTOMERS, access.READ]) && (
        <Route exact path={`${url}/environment`}>
          <Environment customerId={customerId} />
        </Route>
      )}

      {hasAccess([resources.TENANT_SENSITIVE_DATA, access.READ]) && (
        <Route exact path={`${url}/platform`}>
          <Platform customerId={customerId} />
        </Route>
      )}

      {hasAccess([resources.TENANT_SENSITIVE_DATA, access.READ]) && (
        <Route exact path={`${url}/billing`}>
          <Billing customerId={customerId} />
        </Route>
      )}

      {hasAccess([resources.TENANT_LICENSING_DATA, access.READ]) && (
        <Route exact path={`${url}/licensing`}>
          <Licensing customerId={customerId} plan={plan} />
        </Route>
      )}

      {hasAccess([resources.CUSTOMERS, access.READ]) && (
        <Route exact path={`${url}/children`}>
          <Children customerId={customerId} />
        </Route>
      )}
      {hasAccess([resources.TENANT_SENSITIVE_DATA, access.READ]) && (
        <Route exact path={`${url}/customer-arr-activity`}>
          <ArrActivity customerId={customerId} />
        </Route>
      )}

      {hasAccess([resources.TENANT_SENSITIVE_DATA, access.READ]) && (
        <Route exact path={`${url}/satisfaction`}>
          <Satisfaction customerId={customerId} />
        </Route>
      )}

      <Route path="/customers/all-tenants/:id/:tabId/:setings">
        <PlatformRouts />
        <SatisfactionRouts />
      </Route>
      <Route path="/customers/networks/:id/:tabId/:setings">
        <PlatformRouts />
        <SatisfactionRouts />
      </Route>
      <Route path="/customers/applications/:id/:tabId/:setings">
        <PlatformRouts />
        <SatisfactionRouts />
      </Route>
      <Route path="/customers/cancellations/:id/:tabId/:setings">
        <PlatformRouts />
        <SatisfactionRouts />
      </Route>

      <Route path="/interactions/satisfaction-board/:id/:tabId/:setings">
        <PlatformRouts />
        <SatisfactionRouts />
      </Route>
      <Route path="/interactions/qbrs-board/:id/:tabId/:setings">
        <PlatformRouts />
        <SatisfactionRouts />
      </Route>
      <Route path="/interactions/maintenance-windows/:id/:tabId/:setings">
        <PlatformRouts />
        <SatisfactionRouts />
      </Route>
      <Route path="/interactions/sentiment-board/:id/:tabId/:setings">
        <PlatformRouts />
        <SatisfactionRouts />
      </Route>

      <Route path="/cs/versions-activity-log/:id/:tabId/:setings">
        <PlatformRouts />
        <SatisfactionRouts />
      </Route>

      <Route path="/cs/network-rollout/:id/:tabId/:setings">
        <PlatformRouts />
        <SatisfactionRouts />
      </Route>
      <Route path="/cs/cloud-management-log/:id/:tabId/:setings">
        <PlatformRouts />
        <SatisfactionRouts />
      </Route>

      <Route path="/product/features-adoption/:id/:tabId/:setings">
        <PlatformRouts />
        <SatisfactionRouts />
      </Route>

      <Route path="/arr/arr-activity/:id/:tabId/:setings">
        <PlatformRouts />
        <SatisfactionRouts />
      </Route>
    </section>
  );
};

CustomerInfoRoutes.propTypes = {
  url: PropTypes.string,
  customerId: PropTypes.string,
  status: PropTypes.string,
  plan: PropTypes.string
};

export default memo(CustomerInfoRoutes);
